import { render, staticRenderFns } from "./id.vue?vue&type=template&id=10532696&scoped=true"
import script from "./id.vue?vue&type=script&lang=js"
export * from "./id.vue?vue&type=script&lang=js"
import style0 from "./id.vue?vue&type=style&index=0&id=10532696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10532696",
  null
  
)

export default component.exports